// react
import React, { Suspense } from "react";

import Spinner from "../../../components/Spinner/ComponentLoader";
// components
import Config from "./Config";

// hooks
import { useCurrentRouteProps } from "../../../app/router";

// load in the goal tree
const LazyCreateReviewCycle = React.lazy(() => import("./createReviewCycle"));

const CreateReviewCycleLazyLoader = () => {
	const routeProps = useCurrentRouteProps();

	// before rendering the page, we need to set some properties in the config
	// object.
	const [finishedSetup, setFinishedSetup] = React.useState(false);

	React.useEffect(() => {
		Config.pageName = routeProps.pageName;
		setFinishedSetup(true);
	}, [routeProps.pageName]);

	if (!finishedSetup) {
		return <Spinner />;
	}

	return (
		<Suspense fallback={<Spinner />}>
			<LazyCreateReviewCycle />
		</Suspense>
	);
};

export default CreateReviewCycleLazyLoader;
